import { useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'

import styles from './Image.module.scss'

const Image = ({ image, name, handleDelete }) => {
    const [copied, setCopied] = useState(false)

    const imageUrl = `${process.env.REACT_APP_RESOURCE_URI}/${image.Key}`

    return (
        <div key={image.Key} className={styles.image}>
            <div className={styles.imgCard}>
                <div className="text-center">
                    <span className={styles.name} title={name}>{name}</span>
                </div>
                <a href={imageUrl} target="_blank" rel="noopener noreferrer" className="border-top border-bottom">
                    <img src={imageUrl} alt={name} title={name} className="w-100 d-block" style={{ objectFit: 'contain' }} /></a>
                <div className={styles.actions}>
                    <CopyToClipboard text={imageUrl} onCopy={() => setCopied(true)}>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary mr-2">
                            Copy URL
                        </button>
                    </CopyToClipboard>
                    <button type="button" className="btn btn-sm btn-danger" onClick={handleDelete}>Delete</button>
                </div>
            </div>
        </div>
    )
}

export default Image